import {
  CardActionArea,
  CircularProgress,
  ClickAwayListener,
  Divider,
  Icon,
  Modal,
  styled,
  SwipeableDrawer,
  tableRowClasses,
  Container,
  MenuList,
  Menu,
  MenuItem,
  Paper,
  Grid,
  Box,
  Card,
  Tooltip,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import ClearIcon from "@mui/icons-material/Clear";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import LogoutOutlined from "@mui/icons-material/LogoutOutlined";
import LoginOutlined from "@mui/icons-material/LoginOutlined";
import SmsIcon from "@mui/icons-material/Sms";
import CurrencyRubleRounded from "@mui/icons-material/CurrencyRubleRounded";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AddTaskIcon from "@mui/icons-material/AddTask";
import getLPTheme from "../getLPTheme";
import BottomNavigation from "@mui/material/BottomNavigation";
import Puller from "./Puller";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import ReorderIcon from "@mui/icons-material/Reorder";
import MapIcon from "@mui/icons-material/Map";
import SpaIcon from "@mui/icons-material/Spa";
import FilterListIcon from "@mui/icons-material/FilterList";
import App from "./App";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Avatar from "@mui/material/Avatar";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import RestoreIcon from "@mui/icons-material/Restore";
import FavoriteIcon from "@mui/icons-material/Favorite";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import TableCell from "@mui/material/TableCell";
import { useMediaQuery } from "@mui/material";
import FilterIcon from "../images/filter_icon";
import { useTheme } from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";
import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap";
import PlaceIcon from "@mui/icons-material/Place";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Badge from "@mui/material/Badge";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { DateTime } from "luxon";
import Chip from "@mui/material/Chip";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Select from "@mui/material/Select";
import dayjs, { Dayjs } from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Link from "@mui/material/Link";
import { useContext, useEffect, useState, useRef } from "react";
import { SvgIcon } from "@mui/material";
import InfoSmall from "./InfoSmall";
import ImageGallery from "./ImageGallery";
import _ from "lodash";
import { WheelPicker, WheelPickerWrapper } from "@ncdai/react-wheel-picker";
import "@ncdai/react-wheel-picker/style.css";

import { AuthContext } from "../index";
import { GlobalDataContext } from "../index";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import axios from "axios";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Stack from "@mui/material/Stack";
import { compareDesc } from "date-fns";
import {
  LocalizationProvider,
  StaticDatePicker,
  TimeField,
} from "@mui/x-date-pickers";
import { grey } from "@mui/material/colors";

import "./MainScreen.css";
import AuthBySMSInfoSmall from "./AuthBySMSInfoSmall";
import { LocalHospital } from "@mui/icons-material";
import ItemsList from "./ItemsList";
import ItemsListV2 from "./ItemsListV2";
import { getImageV3 } from "../utils/images";
import Info from "./Info";
import PanToolAltIcon from "@mui/icons-material/PanToolAlt";
import { default as PickedServiceInfo } from "./Info";
import {
  getHour,
  getHourMinutes,
  getDay,
  plusDays,
  today,
  tomorrow,
  startOfDay,
  endOfDay,
  getDateString,
  getWeekday,
} from "../utils/dateTime";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { default as FilterInfo } from "./Info";
import { default as ServiceConfirm } from "./InfoSmall";
import { default as ServiceConfirmStatus } from "./InfoSmall";
import { default as RedirectToAuth } from "./InfoSmall";
import { default as FilterInfoV2 } from "./InfoV2";
import { default as ChatModal } from "./InfoV2";
import { default as AddEmptyServiceModal } from "./InfoV2";
import { default as AuthModal } from "./InfoV2";
import Chat from "./Chat";
import React from "react";
import SwipableImageCarousel from "./SwipableImageCarousel";
import BIM_LOGO from "../images/bim_logo_100.png";
import AuthBySMSForm from "./AuthBySMSForm";
import ProfileModal from "./ProfileModal";
import BonusProgramMassageSpecialist from "./BonusProgramMassageSpecialist";

const HOUR_OPTIONS = Array.from({ length: 11 }, (_, i) => ({
  value: i + 10,
  label: String(i + 10).padStart(2, "0"),
}));
const MINUTE_OPTIONS = [0, 15, 30, 45].map((minute) => ({
  value: minute,
  label: String(minute).padStart(2, "0"),
}));
const TIME_WHEEL_CLASS_NAMES = {
  optionItem: "time-wheel-option",
  highlightItem: "time-wheel-highlight",
};

function AppScreen() {
  const { filters, setFilters, messages, handleSendMessage, chats } =
    useContext(GlobalDataContext);
  const { id, userId, phoneNumber, onLogin, onLogout } =
    useContext(AuthContext);

  const navigate = useNavigate();
  const [accountRef, setAccountRef] = React.useState(null);
  const accountMenuRef = React.useRef(null);
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);

  const handleOpenUserMenu = (event) => {
    setAccountRef(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAccountRef(null);
  };

  const _getValueFromFilter = (type, filters) => {
    if (!filters || !filters.filter((f) => f.type == type).length) {
      return null;
    }

    return filters.filter((f) => f.type == type)[0].value;
  };

  const [services, setServices] = useState({
    isLoaded: false,
    data: [],
    grouped: [],
  });

  const DEFAULT_FILTER_INFO_STATE = {
    open: false,
    filters: [...filters],
    calendar: {
      open: false,
    },
  };
  const [filterInfo, setFilterInfo] = useState(DEFAULT_FILTER_INFO_STATE);

  const DEFAULT_REDIRECT_TO_AUTH_STATE = {
    open: false,
  };

  const DEFAULT_SERVICE_CONFIRM_STATUS_STATE = {
    open: false,
    isError: false,
  };

  const [serviceConfirmStatus, setServiceConfirmStatus] = useState(
    DEFAULT_SERVICE_CONFIRM_STATUS_STATE,
  );
  const [redirectToAuth, setRedirectToAuth] = useState(
    DEFAULT_REDIRECT_TO_AUTH_STATE,
  );

  async function loadServices() {
    try {
      const resp = await axios.post(`/api/v1/services/get`, {
        timeFrame: {
          from: _getValueFromFilter("timeFrameFrom", filters),
          to: _getValueFromFilter("timeFrameTo", filters),
        },
      });

      setServices({
        isLoaded: true,
        data: resp.data,
      });
    } catch (err) {
      //noop
    }
  }

  const [showCalendar, setShowCalendar] = useState(false);

  const _handleFilterModalOpen = () => {
    //todo change
    setFilterInfo((prevState) => ({
      ...prevState,
      open: true,
    }));
  };

  const _handleFilterModalClose = () => {
    setFilterInfo((prevState) => ({
      ...prevState,
      open: false,
    }));
  };

  const handleChatOpen = () => {
    setChat((prevState) => ({ ...prevState, open: true }));
  };
  const handleChatClose = () => {
    setChat((prevState) => ({ ...prevState, open: false }));
  };

  const handleProfileOpen = () => {
    setProfile((prevState) => ({ ...prevState, open: true }));
  };
  const handleProfileClose = () => {
    setProfile((prevState) => ({ ...prevState, open: false }));
  };

  const handleBonusProgramOpen = () => {
    setBonusProgram((prevState) => ({ ...prevState, open: true }));
  };
  const handleBonusProgramClose = () => {
    setBonusProgram((prevState) => ({ ...prevState, open: false }));
  };

  const _handleLocationTimeClick = (
    serviceTemplateId,
    locationId,
    timeFrameFrom,
  ) => {
    if (!userId) {
      // setRedirectToAuth(prevState => ({...prevState, open: true}));
      handleAuthModalOpen();
      setServiceDetailed(null);
      return;
    }

    const service = services?.data?.filter(
      (service) =>
        service?.serviceTemplate?.id == serviceTemplateId &&
        service?.location?.id == locationId &&
        service?.timeFrame?.from == timeFrameFrom,
    )[0];

    setServiceConfirm({
      // open: true,
      serviceId: service?.id,
      text: `
            ${service?.serviceTemplate?.title}
            ${getDay(service?.timeFrame?.from)}, c  
            ${getHourMinutes(service?.timeFrame?.from)} по  
            ${getHourMinutes(service?.timeFrame?.to)} \n
            по адресу: ${service?.location?.address}
            `,
      customizations: service?.customizations,
    });
  };

  const _handleServiceBook = async ({ serviceId, customizations }) => {
    if (!serviceId) {
      setServiceConfirm(DEFAULT_SERVICE_CONFIRM_STATE);
      setServiceConfirmStatus({ open: true, isError: true });
    }

    try {
      setServiceConfirm((prevState) => ({ ...prevState, inProgress: true }));

      const resp = await axios.put(`/api/v1/services`, {
        id: serviceId,
        client: {
          id: id,
        },
        customizations: customizations,
      });

      setServiceConfirm(DEFAULT_SERVICE_CONFIRM_STATE);
      setServiceConfirmStatus({ open: true, isError: false });
      setServiceDetailed(null);
      setServices((prevState) => ({ ...prevState, isLoaded: false }));
    } catch (err) {
      setServiceConfirm(DEFAULT_SERVICE_CONFIRM_STATE);
      setServiceConfirmStatus({ open: true, isError: true });
    }
  };

  // todo finished here
  const _getCentralChip = () => {
    const from = getDay(_getValueFromFilter("timeFrameFrom", filters));
    const to = getDay(_getValueFromFilter("timeFrameTo", filters));

    const element = (
      <Stack
        sx={{
          pt: "2px",
          pb: "2px",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          width: "100%",
        }}
        display={"column"}
      >
        <Box
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
            display: "flex",
            width: "100%",
          }}
        >
          <Box
            sx={{
              width: "24px",
              borderRadius: "50%",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={(e) => {
              e.stopPropagation();
              plusDaysToDate(-1);
            }}
          >
            {getDay(today()) !=
              getDay(_getValueFromFilter("timeFrameFrom", filters)) &&
            getDay(_getValueFromFilter("timeFrameFrom", filters)) ==
              getDay(_getValueFromFilter("timeFrameTo", filters)) ? (
              <ArrowBackIosIcon
                fontSize={"small"}
                sx={{
                  color: "gray",
                  ml: 1,
                  display: "block",
                }}
              />
            ) : null}
          </Box>
          <Typography fontSize={"12px"} sx={{ color: "gray" }}>
            <CalendarMonthIcon
              sx={{ fontSize: "12px", fontWeight: "bold", pr: "2px" }}
            />
            {getDay(_getValueFromFilter("timeFrameFrom", filters))}
            {from != to ? <>&nbsp;&ndash;&nbsp;</> : null}
            {from != to
              ? getDay(_getValueFromFilter("timeFrameTo", filters))
              : null}
          </Typography>
          <Box
            sx={{
              width: "24px",
              borderRadius: "50%",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={(e) => {
              e.stopPropagation();
              plusDaysToDate(1);
            }}
          >
            {getDay(_getValueFromFilter("timeFrameFrom", filters)) ==
            getDay(_getValueFromFilter("timeFrameTo", filters)) ? (
              <ArrowForwardIosIcon
                fontSize={"small"}
                sx={{
                  color: "gray",
                  mr: 1,
                  display: "block",
                }}
              />
            ) : null}
          </Box>
        </Box>
      </Stack>
    );

    return (
      <Box
        sx={{
          display: "flex",
          borderRadius: "30px",
          border: "1px solid #ddd",
          justifyContent: "center",
          alignItems: "center",
          p: "5px",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
        }}
        // onClick={() => {
        //    setFilterInfo(prevState => ({...prevState, open: true}));
        // }}
      >
        {element}
      </Box>
    );
  };

  const handleDatePickV2 = (newDate, type) => {
    setFilterInfo((prevState) => {
      let nextFilters = [...(prevState?.filters ?? [])];

      if (type == "from") {
        const ixFrom = nextFilters.findIndex(
          (fltr) => fltr.type == "timeFrameFrom",
        );
        if (ixFrom != -1) {
          nextFilters.splice(ixFrom, 1);
        }

        nextFilters.push({
          type: "timeFrameFrom",
          value: startOfDay(newDate / 1000),
        });
      }

      if (type == "to") {
        const ixTo = nextFilters.findIndex(
          (fltr) => fltr.type == "timeFrameTo",
        );
        if (ixTo != -1) {
          nextFilters.splice(ixTo, 1);
        }

        nextFilters.push({
          type: "timeFrameTo",
          value: endOfDay(newDate / 1000),
        });
      }

      return {
        ...prevState,
        calendar: { ...prevState?.calendar, openFrom: false, openTo: false },
        filters: [...nextFilters],
      };
    });
  };

  const plusDaysToDate = (day) => {
    day = parseInt(day);
    setFilters((prevState) => {
      const nextFilters = [...filters];
      let newDateFrom = 0;
      const ixFrom = nextFilters.findIndex(
        (fltr) => fltr.type == "timeFrameFrom",
      );
      if (ixFrom != -1) {
        newDateFrom = new Date(parseInt(nextFilters[ixFrom].value * 1000));
        newDateFrom.setDate(newDateFrom.getDate() + day);

        nextFilters.splice(ixFrom, 1);
      }

      let newDateTo = 0;
      const ixTo = nextFilters.findIndex((fltr) => fltr.type == "timeFrameTo");
      if (ixTo != -1) {
        newDateTo = new Date(parseInt(nextFilters[ixTo].value * 1000));
        newDateTo.setDate(newDateTo.getDate() + day);

        nextFilters.splice(ixTo, 1);
      }

      return [
        ...nextFilters,
        { type: "timeFrameFrom", value: startOfDay(newDateFrom / 1000) },
        { type: "timeFrameTo", value: endOfDay(newDateTo / 1000) },
      ];
    });
  };

  useEffect(() => {
    setServices((prevState) => ({ ...prevState, isLoaded: false }));
    setFilterInfo(DEFAULT_FILTER_INFO_STATE);
  }, [filters]);

  const handleDiscountPickV2 = () => {
    setFilterInfo((prevState) => {
      const nextFilters = [...(prevState?.filters ?? [])];
      const ix = nextFilters.findIndex((fltr) => fltr.type == "discount");
      if (ix != -1) {
        const currValue = nextFilters[ix].value;
        nextFilters.splice(ix, 1);
        nextFilters.push({ type: "discount", value: !currValue });
      } else {
        nextFilters.push({ type: "discount", value: true });
      }

      return {
        ...prevState,
        filters: [...nextFilters],
      };
    });
  };

  const DEFAULT_AUTH_MODAL_STATE = {
    open: false,
  };
  const [authModal, setAuthModal] = useState(DEFAULT_AUTH_MODAL_STATE);

  const handleAuthModalOpen = () => {
    setAuthModal((prevState) => ({ ...prevState, open: true }));
  };

  const handleAuthModalClose = () => {
    setAuthModal((prevState) => ({ ...prevState, open: false }));
  };

  const isPickedDateTime = (locationItem, timeFrame) => {
    const filteredServices = services?.data?.filter(
      (service) => service?.id == serviceConfirm?.serviceId,
    );
    if (
      filteredServices?.length &&
      filteredServices[0].serviceTemplate?.id ==
        serviceDetailed?.serviceTemplate?.id &&
      locationItem?.id == filteredServices[0]?.location?.id &&
      timeFrame?.from == filteredServices[0]?.timeFrame?.from
    ) {
      return true;
    }
    return false;
  };

  const [serviceDetailed, setServiceDetailed] = useState(null);
  useEffect(() => {
    if (serviceDetailed == null) {
      setServiceConfirm(DEFAULT_SERVICE_CONFIRM_STATUS_STATE);
    }
  }, [serviceDetailed]);

  const [locationDetailed, setLocationDetailed] = useState(null);
  const [mapDetailed, setMapDetailed] = useState(null);
  const [serviceBook, setServiceBook] = useState({ isLoaded: true });
  const datePlaceSection = useRef(null);

  const [button, setButton] = useState({ text: "", loading: false });
  let handleButtonClick = () => {};
  let setButtonClick = (action) => {
    handleButtonClick = action;
  };

  // new components
  const [specialistServices, setSpecialistServices] = useState({
    isLoaded: false,
    data: [],
  });

  async function loadServices() {
    try {
      const resp = await axios.post(`/api/v1/services/get`, {
        specialistIds: [id],
        timeFrame: {
          from: _getValueFromFilter("timeFrameFrom", filters),
          to: _getValueFromFilter("timeFrameTo", filters),
        },
      });

      setSpecialistServices({ isLoaded: true, data: resp?.data });
    } catch (err) {
      throw err;
    }
  }

  useEffect(() => {
    if (userId && !specialistServices.isLoaded) {
      loadServices();
    }
  }, [userId, specialistServices.isLoaded]);

  const DEFAULT_EMPTY_SERVICE = {
    open: false,
    calendar: {
      open: false,
      date: DateTime.now(),
    },
    time: {
      open: false,
      from: DateTime.now().set({ hour: "10", minute: "00" }),
      to: DateTime.now().set({ hour: "20", minute: "00" }),
    },
  };
  const [emptyService, setEmptyService] = useState(DEFAULT_EMPTY_SERVICE);

  const handleAddEmptyService = () => {
    setEmptyService((ps) => ({ ...ps, open: true }));
  };

  const handleDeleteService = async (serviceId) => {
    try {
      const resp = await axios.delete(`/api/v1/services/${serviceId}`);
      loadServices();
    } catch (err) {
      throw err;
    }
  };

  const handleCancelService = async (serviceId) => {
    try {
      const resp = await axios.put(`/api/v1/services`, {
        id: serviceId,
        specialist: {
          id: null,
        },
      });
      setServiceDetailed(null);
      setSpecialistServices((prevState) => ({ ...prevState, isLoaded: false }));
    } catch (err) {
      throw err;
    }
  };

  const handleCreateEmptyService = () => {
    async function createEmptyService() {
      try {
        const resp = await axios.post(`/api/v1/services`, {
          specialist: {
            id: id,
          },
          timeFrame: {
            from: emptyService?.time?.from?.toUnixInteger(),
            to: emptyService?.time?.to?.toUnixInteger(),
          },
        });

        setEmptyService(DEFAULT_EMPTY_SERVICE);
        loadServices();
      } catch (err) {
        throw err;
      }
    }

    createEmptyService();
  };

  const handleDefaultEmptyService = () => {
    setEmptyService((ps) => ({ ...DEFAULT_EMPTY_SERVICE, open: true }));
  };

  // mock here
  const DEFAULT_SERVICE_CONFIRM_STATE = {
    serviceId: null,
    text: "",
    customizations: [],
    inProgress: false,
  };

  const [serviceConfirm, setServiceConfirm] = useState(
    DEFAULT_SERVICE_CONFIRM_STATE,
  );

  const [chat, setChat] = useState({ open: false });
  const [chatDetailed, setChatDetailed] = useState(null);

  const [profile, setProfile] = useState({ open: false });

  const [bonusProgram, setBonusProgram] = useState({ open: false });
  useEffect(() => {
    if (!chatDetailed && chats?.isLoaded && chats?.data?.length) {
      setChatDetailed(_.head(chats.data));
    }
  }, [chatDetailed, chats?.isLoaded, chats?.data]);

  return (
    <App
      top={
        <Stack
          direction={"row"}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pl: 4,
            pr: 4,
            backgroundColor: "#fcfcfc",
            // boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
            isolation: "isolate",
          }}
        >
          <Container
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Stack
              direction="row"
              sx={{
                p: 2,
                pb: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  height: "25px",
                  "&:hover": { cursor: "pointer" },
                  mr: "4px",
                }}
                component={"img"}
                onClick={() => navigate("/")}
                src={BIM_LOGO}
              />
              <Typography
                sx={{
                  fontSize: "22px",
                  fontWeight: "300",
                  color: "gray",
                  alignSelf: "flex-end",
                  lineHeight: 1,
                }}
              >
                | специалисты
              </Typography>
            </Stack>
            <Stack
              spacing={3}
              direction="row"
              sx={{
                p: 2,
                display: "flex",
                // flexGrow: 0,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box>
                <Badge
                  badgeContent={
                    filters.filter((it) => it.type != "timeFrameTo").length
                  }
                  color={"primary"}
                  onClick={_handleFilterModalOpen}
                  sx={{
                    "&:hover": { cursor: "pointer" },
                    // borderRadius: '15px',
                    // p: '2px',
                    // border: "1px solid gray"
                  }}
                >
                  <Chip
                    sx={{ fontSize: "10px" }}
                    label={"Фильтры"}
                    onClick={_handleFilterModalOpen}
                  ></Chip>
                  {/*<FilterListIcon*/}
                  {/*    sx={{color: 'gray'}}*/}
                  {/*/>*/}
                </Badge>
              </Box>
              {_getCentralChip()}
              <Button
                variant={"outlined"}
                onClick={handleAddEmptyService}
                sx={{ display: "flex", alignItems: "center", height: "34px" }}
              >
                <AddIcon
                  fontSize={"medium"}
                  sx={{
                    m: 0,
                    color: "gray",
                    fontWeight: "300",
                    // border: '1px solid gray',
                    // borderRadius: '50%'
                  }}
                />
                <Typography
                  sx={{
                    color: "gray",
                    fontSize: "14px",
                    lineHeight: 1,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Создать
                </Typography>
              </Button>
            </Stack>
            <Box>
              <Tooltip title="">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <AccountCircleIcon
                    sx={{
                      fontSize: "30px",
                      color: "#e3e3e3",
                      "&:hover": { cursor: "pointer" },
                    }}
                  />
                </IconButton>
              </Tooltip>
              <Menu
                anchorEl={accountRef}
                open={Boolean(accountRef)}
                sx={{ mt: "45px" }}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                onClose={handleCloseUserMenu}
              >
                {userId ? (
                  <MenuItem
                    onClick={() => {
                      handleProfileOpen();
                      handleCloseUserMenu();
                    }}
                  >
                    <Stack direction={"row"} alignItems={"center"}>
                      <AccountCircleIcon
                        sx={{
                          fontSize: "12px",
                          pr: 1,
                          color: "rgb(0 0 0/0.75)",
                        }}
                      />
                      <Typography
                        fontSize={"16px"}
                        sx={{ color: "rgb(0 0 0/ 0.7)" }}
                      >
                        Профиль
                      </Typography>
                    </Stack>
                  </MenuItem>
                ) : null}
                {userId ? (
                  <MenuItem
                    onClick={() => {
                      handleBonusProgramOpen();
                      handleCloseUserMenu();
                    }}
                  >
                    <Stack direction={"row"} alignItems={"center"}>
                      <CurrencyRubleRounded
                        sx={{
                          fontSize: "12px",
                          pr: 1,
                          color: "rgb(0 0 0/0.75)",
                        }}
                      />
                      <Typography
                        fontSize={"16px"}
                        sx={{ color: "rgb(0 0 0/ 0.7)" }}
                      >
                        Бонусная программа
                      </Typography>
                    </Stack>
                  </MenuItem>
                ) : null}
                {userId ? (
                  <MenuItem
                    onClick={() => {
                      handleChatOpen();
                      handleCloseUserMenu();
                    }}
                  >
                    <Stack direction={"row"} alignItems={"center"}>
                      <SmsIcon
                        sx={{
                          fontSize: "12px",
                          pr: 1,
                          color: "rgb(0 0 0/0.75)",
                        }}
                      />
                      <Typography
                        fontSize={"16px"}
                        sx={{ color: "rgb(0 0 0/ 0.7)" }}
                      >
                        Чаты
                      </Typography>
                    </Stack>
                  </MenuItem>
                ) : null}
                {userId ? (
                  <MenuItem onClick={onLogout}>
                    <Stack direction={"row"} alignItems={"center"}>
                      <LogoutOutlined
                        sx={{
                          fontSize: "12px",
                          pr: 1,
                          color: "rgb(0 0 0/0.75)",
                        }}
                      />
                      <Typography
                        fontSize={"16px"}
                        sx={{ color: "rgb(0 0 0/ 0.7)" }}
                      >
                        Выйти
                      </Typography>
                    </Stack>
                  </MenuItem>
                ) : null}
                {!userId ? (
                  <MenuItem>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      onClick={() => {
                        handleAuthModalOpen();
                        handleCloseUserMenu();
                      }}
                    >
                      <LoginOutlined
                        sx={{
                          fontSize: "12px",
                          pr: 1,
                          color: "rgb(0 0 0/0.75)",
                        }}
                      />
                      <Typography
                        fontSize={"10px"}
                        sx={{ color: "rgb(0 0 0/ 0.7)" }}
                      >
                        Войти
                      </Typography>
                    </Stack>
                  </MenuItem>
                ) : null}
              </Menu>
            </Box>
          </Container>
        </Stack>
      }
    >
      {/* main component */}
      <Container sx={{ pt: 3 }}>
        <ItemsListV2
          sxExtra={{
            minWidth: {
              xs: "80%",
              sm: "70%",
              md: "50%",
            },
          }}
          itemsLoading={!specialistServices.isLoaded}
          closeDetailed={() => {
            setServiceDetailed(null);
          }}
          items={specialistServices.data
            .sort(
              (left, right) => left?.timeFrame?.from - right?.timeFrame?.from,
            )
            .reduce((acc, curr) => {
              //todo: change
              const dayString = getDateString(
                DateTime.fromSeconds(curr.timeFrame.from),
              );
              const dayStringFormatted =
                getWeekday(curr.timeFrame.from) +
                " - " +
                getDay(curr.timeFrame.from);
              const idx = acc.findIndex((it) => it.dayString == dayString);

              if (idx != -1) {
                acc[idx].data.push(curr);
              } else {
                acc.push({
                  dayStringFormatted: dayStringFormatted,
                  day: getDay(curr?.timeFrame?.from),
                  weekday: getWeekday(curr?.timeFrame?.from),
                  dayString: dayString,
                  data: [curr],
                });
              }

              return acc;
            }, [])
            .map((sg) => (
              <Grid item xs={12} sx={{ mt: 2 }}>
                <Stack direction={"row"}>
                  <Typography
                    align={"left"}
                    color={"gray"}
                    fontSize={"20px"}
                    sx={{ width: "10%", p: 1 }}
                  >
                    {sg.day}
                  </Typography>
                  <Typography
                    align={"left"}
                    color={"gray"}
                    fontSize={"20px"}
                    sx={{ width: "20%", p: 1 }}
                  >
                    {sg.weekday}
                  </Typography>
                  <ItemsListV2
                    itemsLoading={!specialistServices.isLoaded}
                    closeDetailed={() => {
                      setServiceDetailed(null);
                    }}
                    items={
                      sg.data.length ? (
                        sg.data.map((item) => (
                          <Grid item xs={12} sx={{ mt: 1 }}>
                            <Box
                              sx={{
                                borderRadius: "24px",
                                boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                              }}
                              onClick={() => {
                                setServiceDetailed(item);
                              }}
                            >
                              <CardActionArea
                                disableRipple
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "flex-start",
                                }}
                                onClick={() => {
                                  setServiceDetailed(item);
                                }}
                              >
                                {item?.serviceTemplate?.id ? (
                                  <CardMedia
                                    component="img"
                                    sx={{
                                      width: 100,
                                      height: 100,
                                      m: "2px",
                                      borderRadius: "24px",
                                    }}
                                    image={getImageV3(
                                      _.nth(
                                        item?.serviceTemplate?.images.map(
                                          (im) => im?.id,
                                        ),
                                        0,
                                      ),
                                    )}
                                    alt=""
                                  />
                                ) : null}
                                <CardContent
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "flex-start",
                                    height: "100%",
                                    width: "100%",
                                  }}
                                >
                                  {item?.serviceTemplate?.id ? (
                                    <Typography
                                      sx={{ fontSize: "16px" }}
                                      align={"left"}
                                    >
                                      {" "}
                                      {` ${item?.serviceTemplate?.title}: ${getHourMinutes(item?.timeFrame?.from)} - ${getHourMinutes(item?.timeFrame?.to)}`}
                                    </Typography>
                                  ) : (
                                    <Typography
                                      sx={{ fontSize: "16px" }}
                                      align={"left"}
                                    >
                                      {" "}
                                      {`Рабочее время: ${getHourMinutes(item?.timeFrame?.from)} - ${getHourMinutes(item?.timeFrame?.to)}`}{" "}
                                    </Typography>
                                  )}
                                  {item?.serviceTemplate?.id ? (
                                    item?.client?.id ? (
                                      <Typography
                                        align={"left"}
                                        fontSize={"14px"}
                                      >
                                        {" "}
                                        Занято{" "}
                                      </Typography>
                                    ) : (
                                      <Typography
                                        align={"left"}
                                        fontSize={"14px"}
                                      >
                                        {" "}
                                        Без клиента{" "}
                                      </Typography>
                                    )
                                  ) : null}
                                </CardContent>
                              </CardActionArea>
                            </Box>
                          </Grid>
                        ))
                      ) : (
                        <Typography sx={{ color: "gray", fontSize: "14px" }}>
                          Сервисов для указанных фильтров не найдено
                        </Typography>
                      )
                    }
                  />
                </Stack>
              </Grid>
            ))}
          itemDetailed={
            serviceDetailed ? (
              <Container maxWidth={"md"}>
                <Stack
                  sx={{
                    height: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      overflowY: "auto",
                      height: "100%",
                    }}
                  >
                    {serviceDetailed?.serviceTemplate?.images?.length ? (
                      <Box
                        sx={{
                          width: "100%",
                          aspectRatio: "3/1",
                          overflow: "hidden",
                          borderRadius: "20px 20px 0 0",
                        }}
                      >
                        <CardMedia
                          component="img"
                          sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                          image={_.head(
                            serviceDetailed?.serviceTemplate?.images?.map(
                              (it) => getImageV3(it?.id),
                            ),
                          )}
                          alt=""
                        />
                      </Box>
                    ) : null}
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                      <Grid item xs={8}>
                        {serviceDetailed?.serviceTemplate?.title ? (
                          <Typography
                            align="center"
                            sx={{ pb: 2, fontSize: "24px" }}
                          >
                            {serviceDetailed?.serviceTemplate?.title}
                          </Typography>
                        ) : null}
                        {serviceDetailed?.serviceTemplate?.description ? (
                          <Typography
                            align="center"
                            sx={{ fontSize: "12px", color: "gray" }}
                          >
                            {serviceDetailed?.serviceTemplate?.description}
                          </Typography>
                        ) : null}
                        {serviceDetailed?.client?.id ? (
                          <>
                            <Typography sx={{ pt: 2 }} align={"left"}>
                              Клиент
                            </Typography>
                            <Typography sx={{ fontSize: "12px" }} align="left">
                              {serviceDetailed?.client?.firstName}
                            </Typography>
                          </>
                        ) : null}
                        {serviceDetailed?.customizations?.wish?.data ? (
                          <>
                            <Typography sx={{ pt: 2 }} align={"left"}>
                              Пожелания
                            </Typography>
                            <Typography sx={{ fontSize: "12px" }} align="left">
                              {serviceDetailed?.customizations?.wish?.data}
                            </Typography>
                          </>
                        ) : null}
                        {serviceDetailed?.customizations?.cosmetics?.data ? (
                          <>
                            <Typography sx={{ pt: 2 }} align={"left"}>
                              Косметика
                            </Typography>
                            <Typography sx={{ fontSize: "12px" }} align="left">
                              {
                                serviceDetailed?.customizations?.cosmetics?.data?.filter(
                                  (it) => it.checked,
                                )[0].title
                              }
                            </Typography>
                          </>
                        ) : null}
                        <Typography sx={{ pt: 2 }} align={"left"}>
                          Место и время
                        </Typography>
                        <Stack sx={{ justifyContent: "flex-end" }}>
                          <Typography
                            sx={{ pb: 1 }}
                          >{`${getDay(serviceDetailed?.timeFrame?.from) + " с " + getHourMinutes(serviceDetailed?.timeFrame?.from) + " по " + getHourMinutes(serviceDetailed?.timeFrame?.to)}`}</Typography>
                        </Stack>

                        {serviceDetailed?.location?.address ? (
                          <Stack sx={{ justifyContent: "flex-end" }}>
                            <Typography
                              sx={{ pb: 1 }}
                            >{`${serviceDetailed?.location?.address}`}</Typography>
                          </Stack>
                        ) : null}
                      </Grid>
                      <Grid item xs={4}>
                        <Box sx={{ p: 2 }}>
                          <Stack
                            direction={"row"}
                            sx={{ justifyContent: "center" }}
                            spacing={2}
                          >
                            <Button
                              disabled={serviceDetailed?.client?.id}
                              variant={"contained"}
                              onClick={() => {
                                handleCancelService(serviceDetailed?.id);
                              }}
                              sx={{
                                flex: "1 1 auto",
                                maxWidth: "300px",
                              }}
                            >
                              Отменить слот
                            </Button>
                          </Stack>
                          {serviceDetailed?.client?.id ? (
                            <Typography fontSize={"10px"} align={"center"}>
                              * Для отмены услуги с клиентом обратитесь к
                              администратору
                            </Typography>
                          ) : null}
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Stack>
              </Container>
            ) : null
          }
        />
      </Container>

      {/*helper components*/}
      <AddEmptyServiceModal
        open={emptyService.open}
        handleClose={() => {
          setEmptyService((ps) => ({ ...ps, open: false }));
        }}
      >
        <Stack
          sx={{
            height: "100%",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ p: 2, pt: 4, pb: 4 }}>
            <Typography
              align={"center"}
              sx={{ fontWeight: "bold", fontSize: "22px" }}
            >
              Рабочее время
            </Typography>
          </Box>
          <Box sx={{ overflowY: "auto", height: "100%" }}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              sx={{
                pt: 1,
                pb: 1,
                pr: 1,
              }}
            >
              <CalendarMonthIcon sx={{ p: 2, color: "rgb(0 0 0/0.75)" }} />
              <Stack
                direction={"row"}
                sx={{
                  width: "100%",
                  pb: 1,
                  "&:hover": {
                    cursor: "pointer",
                    backgroundColor: "rgb(0 0 0 / 0.01)",
                  },
                }}
                onClick={() => {
                  setEmptyService((ps) => ({
                    ...ps,
                    calendar: { ...ps?.calendar, open: !ps?.calendar?.open },
                  }));
                }}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Stack>
                  <Typography
                    fontSize={"12px"}
                    sx={{ color: "rgb(0 0 0/ 0.7)" }}
                  >
                    Дата
                  </Typography>
                  <Typography>
                    {getDay(emptyService?.calendar?.date)}
                  </Typography>
                </Stack>
              </Stack>
              <ArrowForwardIosIcon
                onClick={() => {
                  setEmptyService((ps) => ({
                    ...ps,
                    calendar: { ...ps?.calendar, open: !ps?.calendar?.open },
                  }));
                }}
                sx={{
                  p: 2,
                  color: "rgb(0 0 0/0.75)",
                  fontSize: "16px",
                  rotate: emptyService.calendar.open ? "90deg" : "none",
                }}
              />
            </Stack>
            {emptyService?.calendar?.open ? (
              <LocalizationProvider
                dateAdapter={AdapterLuxon}
                adapterLocale={"ru"}
              >
                <StaticDatePicker
                  onChange={(newDate) => {
                    const from = newDate.set({ hour: "10", minute: "00" });
                    const to = newDate.set({ hour: "20", minute: "00" });
                    setEmptyService((ps) => ({
                      ...ps,
                      calendar: { ...ps?.calendar, open: false, date: newDate },
                      time: { from: from, to: to },
                    }));
                  }}
                  onClose={() => {
                    setEmptyService((ps) => ({
                      ...ps,
                      calendar: { ...ps?.calendar, open: false },
                    }));
                  }}
                  views={["month", "day"]}
                  value={emptyService?.calendar?.date}
                  disablePast
                  slotProps={{
                    toolbar: {
                      hidden: true,
                    },
                  }}
                  slots={{
                    actionBar: () => null,
                  }}
                />
              </LocalizationProvider>
            ) : null}
            <Stack
              direction={"row"}
              alignItems={"center"}
              sx={{
                pt: 1,
                pb: 1,
                pr: 1,
              }}
            >
              <Stack
                sx={{
                  width: "100%",
                  pb: 1,
                  "&:hover": {
                    cursor: "pointer",
                    backgroundColor: "rgb(0 0 0 / 0.01)",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "max-content max-content max-content 1fr",
                    columnGap: 2,
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Box />
                  <Typography
                    fontSize={"12px"}
                    sx={{ color: "rgb(0 0 0/ 0.7)" }}
                  >
                    С
                  </Typography>
                  <Typography
                    fontSize={"12px"}
                    sx={{ color: "rgb(0 0 0/ 0.7)" }}
                  >
                    По
                  </Typography>
                  <Box />

                  <AccessTimeIcon sx={{ p: 2, color: "rgb(0 0 0/0.75)" }} />
                  <LocalizationProvider
                    dateAdapter={AdapterLuxon}
                    adapterLocale={"ru"}
                  >
                    <TimeField
                      value={emptyService?.time?.from}
                      disabled={true}
                      size={"small"}
                    />
                  </LocalizationProvider>
                  <LocalizationProvider
                    dateAdapter={AdapterLuxon}
                    adapterLocale={"ru"}
                  >
                    <TimeField
                      value={emptyService?.time?.to}
                      disabled={true}
                      size={"small"}
                    />
                  </LocalizationProvider>

                  <ArrowForwardIosIcon
                    onClick={() => {
                      setEmptyService((ps) => ({
                        ...ps,
                        time: { ...ps?.time, open: !ps?.time?.open },
                      }));
                    }}
                    sx={{
                      justifySelf: "end",
                      p: 2,
                      color: "rgb(0 0 0/0.75)",
                      fontSize: "16px",
                      rotate: emptyService.time.open ? "90deg" : "none",
                    }}
                  />

                  {emptyService?.time?.open ? <Box /> : null}
                  {emptyService?.time?.open ? (
                    <WheelPickerWrapper className={"time-wheel-wrapper"}>
                      <WheelPicker
                        options={HOUR_OPTIONS}
                        value={emptyService?.time?.from?.hour ?? 10}
                        onValueChange={(value) => {
                          setEmptyService((ps) => ({
                            ...ps,
                            time: {
                              ...ps.time,
                              from: (ps?.time?.from ?? DateTime.now()).set({
                                hour: value,
                              }),
                            },
                          }));
                        }}
                        infinite
                        visibleCount={12}
                        classNames={TIME_WHEEL_CLASS_NAMES}
                      />
                      <WheelPicker
                        options={MINUTE_OPTIONS}
                        value={emptyService?.time?.from?.minute ?? 0}
                        onValueChange={(value) => {
                          setEmptyService((ps) => ({
                            ...ps,
                            time: {
                              ...ps.time,
                              from: (ps?.time?.from ?? DateTime.now()).set({
                                minute: value,
                              }),
                            },
                          }));
                        }}
                        infinite
                        visibleCount={12}
                        classNames={TIME_WHEEL_CLASS_NAMES}
                      />
                    </WheelPickerWrapper>
                  ) : null}
                  {emptyService?.time?.open ? (
                    <WheelPickerWrapper className={"time-wheel-wrapper"}>
                      <WheelPicker
                        options={HOUR_OPTIONS}
                        value={emptyService?.time?.to?.hour ?? 20}
                        onValueChange={(value) => {
                          setEmptyService((ps) => ({
                            ...ps,
                            time: {
                              ...ps.time,
                              to: (ps?.time?.to ?? DateTime.now()).set({
                                hour: value,
                              }),
                            },
                          }));
                        }}
                        infinite
                        visibleCount={12}
                        classNames={TIME_WHEEL_CLASS_NAMES}
                      />
                      <WheelPicker
                        options={MINUTE_OPTIONS}
                        value={emptyService?.time?.to?.minute ?? 0}
                        onValueChange={(value) => {
                          setEmptyService((ps) => ({
                            ...ps,
                            time: {
                              ...ps.time,
                              to: (ps?.time?.to ?? DateTime.now()).set({
                                minute: value,
                              }),
                            },
                          }));
                        }}
                        infinite
                        visibleCount={12}
                        classNames={TIME_WHEEL_CLASS_NAMES}
                      />
                    </WheelPickerWrapper>
                  ) : null}
                </Box>
              </Stack>
            </Stack>
          </Box>
          <Box sx={{ p: 2 }}>
            <Stack
              direction={"row"}
              sx={{ justifyContent: "center" }}
              spacing={2}
            >
              <Button
                sx={{ mt: 4, width: "100%" }}
                variant={"outlined"}
                onClick={handleDefaultEmptyService}
                sx={{
                  flex: "1 1 auto",
                  maxWidth: "300px",
                }}
              >
                Сбросить
              </Button>
              <Button
                sx={{ mt: 4, width: "100%" }}
                variant={"contained"}
                onClick={handleCreateEmptyService}
                sx={{
                  flex: "1 1 auto",
                  maxWidth: "300px",
                }}
              >
                Добавить
              </Button>
            </Stack>
          </Box>
        </Stack>
      </AddEmptyServiceModal>
      <ChatModal
        open={chat.open}
        handleClose={handleChatClose}
        sxExtra={{
          minWidth: {
            xs: "80%",
            sm: "70%",
            md: "50%",
          },
          height: {
            xs: "90%",
            sm: "80%",
            md: "70%",
          },
          pl: 1,
        }}
      >
        <Container sx={{ height: "100%", minHeight: 0 }}>
          <Grid
            container
            minWidth={"md"}
            sx={{
              height: "100%",
              flexWrap: "nowrap",
            }}
          >
            <Grid xs={4} sx={{ overflowY: "auto", height: "100%" }}>
              <Stack>
                {chats?.data?.length
                  ? chats?.data?.map((item) => (
                      <Card
                        // elevation={1}
                        // key={item.id}
                        // sx={{display: 'flex', '&:hover':  { border: '1px solid #2999ff'}, '&:focus': {outline: 'none'}}}
                        sx={{ border: "none" }}
                        onClick={() => {
                          setChatDetailed(item);
                        }}
                      >
                        <CardActionArea
                          disableRipple
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                          }}
                          onClick={() => {
                            // handleServicePick(item)
                          }}
                        >
                          <CardMedia
                            component="img"
                            sx={{
                              width: 75,
                              height: 75,
                              p: 1,
                              borderRadius: "50%",
                              // ...(now() > item?.timeFrame?.to && {opacity: '0.5'})
                            }}
                            image={getImageV3(
                              item?.images?.map((im) => im.id)[0],
                            )}
                            alt=""
                          />
                          <CardContent
                            sx={{
                              display: "block",
                              flexGrow: 1,
                              alignSelf: "stretch",
                              borderBottom: "1px solid #e3e3e3",
                            }}
                          >
                            <Stack>
                              <Typography
                                align={"left"}
                                sx={{ color: "black" }}
                              >
                                {" "}
                                {item?.title}{" "}
                              </Typography>
                              <Typography
                                align={"left"}
                                sx={{ fontSize: "12px", color: "gray" }}
                              >
                                {_.truncate(_.nth(messages?.data?.filter(message => message?.chatId === item?.chatId), -1)?.text, {
                                  length: 50,
                                  separator: " ",
                                })}
                              </Typography>
                            </Stack>

                            {
                              // now() > item?.timeFrame?.to ? <Typography sx={{fontSize: '12px'}} align={'left'}>прошедший </Typography> : null
                            }
                            {/*<Typography sx={{fontSize: '16px'}} align={'left'}> { item?.serviceTemplate?.title }</Typography>*/}
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    ))
                  : null}
              </Stack>
            </Grid>
            <Grid xs={8} sx={{ overflowY: "auto", height: "100%" }}>
              {chatDetailed ? (
                <Box
                  sx={{
                    backgroundColor: "#fff",
                    overflow: "hidden",
                    height: "100%",
                  }}
                >
                  <Chat
                    sx={{ backgroundColor: "#fff", overflowY: "auto" }}
                    specialistId={id}
                    messages={_.filter(messages?.data, (it) => {
                      return it?.chatId === chatDetailed?.chatId;
                    })}
                    addMessage={(text, type) => {
                      handleSendMessage(chatDetailed?.chatId, text, type);
                    }}
                  />
                </Box>
              ) : null}
            </Grid>
          </Grid>
        </Container>
      </ChatModal>
      <AuthModal open={authModal.open} handleClose={handleAuthModalClose}>
        <Stack
          spacing={3}
          sx={{ justifyContent: "center", alignItems: "center" }}
        >
          <Box
            sx={{ height: "30px" }}
            component={"img"}
            alt={"Логотип компании Bim"}
            src={BIM_LOGO}
          />
          <Typography component="h1" variant="h5">
            Войдите в аккаунт
          </Typography>
          <AuthBySMSForm
            setButton={setButton}
            setButtonClick={setButtonClick}
            onLoginSuccess={() => {
              setAuthModal((prevState) => ({ ...prevState, open: false }));
            }}
          />
        </Stack>
      </AuthModal>
      <FilterInfoV2
        open={filterInfo.open}
        handleClose={_handleFilterModalClose}
      >
        <Stack
          sx={{
            height: "100%",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ pb: 4 }}>
            <Typography
              align={"center"}
              sx={{ fontWeight: "bold", fontSize: "22px" }}
            >
              Фильтры
            </Typography>
          </Box>
          <Box sx={{ overflowY: "auto", height: "100%" }}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              sx={{
                pt: 1,
                pb: 1,
                pr: 1,
              }}
            >
              <CalendarMonthIcon sx={{ p: 2, color: "rgb(0 0 0/0.75)" }} />
              <Stack
                direction={"row"}
                sx={{
                  width: "100%",
                  // borderBottom: '1px solid rgb(0 0 0 / 0.1)',
                  pb: 1,
                }}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Stack
                  sx={{
                    flex: "1 1 auto",
                    justifyContent: "space-between",
                    "&:hover": {
                      cursor: "pointer",
                      backgroundColor: "rgb(0 0 0 / 0.01)",
                    },
                  }}
                  direction={"row"}
                  onClick={() => {
                    setFilterInfo((prevState) => ({
                      ...prevState,
                      calendar: {
                        ...prevState.calendar,
                        openFrom: !prevState?.calendar?.openFrom,
                        openTo: false,
                      },
                    }));
                    setShowCalendar((prevState) => !prevState);
                  }}
                >
                  <Stack>
                    <Typography
                      fontSize={"12px"}
                      sx={{ color: "rgb(0 0 0/ 0.7)" }}
                    >
                      С даты
                    </Typography>
                    <Typography>
                      {getDay(
                        _getValueFromFilter(
                          "timeFrameFrom",
                          filterInfo?.filters,
                        ),
                      )}
                    </Typography>
                  </Stack>
                  <ArrowForwardIosIcon
                    sx={{
                      p: 2,
                      color: "rgb(0 0 0/0.75)",
                      fontSize: "16px",
                      rotate: filterInfo.calendar.openFrom ? "90deg" : "none",
                    }}
                  />
                </Stack>
                <Stack
                  sx={{
                    flex: "1 1 auto",
                    justifyContent: "space-between",
                    "&:hover": {
                      cursor: "pointer",
                      backgroundColor: "rgb(0 0 0 / 0.01)",
                    },
                  }}
                  direction={"row"}
                  onClick={() => {
                    setFilterInfo((prevState) => ({
                      ...prevState,
                      calendar: {
                        ...prevState.calendar,
                        openTo: !prevState?.calendar?.openTo,
                        openFrom: false,
                      },
                    }));
                    setShowCalendar((prevState) => !prevState);
                  }}
                >
                  <Stack>
                    <Typography
                      fontSize={"12px"}
                      sx={{ color: "rgb(0 0 0/ 0.7)" }}
                    >
                      По дату
                    </Typography>
                    <Typography>
                      {getDay(
                        _getValueFromFilter("timeFrameTo", filterInfo?.filters),
                      )}
                    </Typography>
                  </Stack>
                  <ArrowForwardIosIcon
                    sx={{
                      p: 2,
                      color: "rgb(0 0 0/0.75)",
                      fontSize: "16px",
                      rotate: filterInfo.calendar.openTo ? "90deg" : "none",
                    }}
                  />
                </Stack>
              </Stack>
            </Stack>
            {filterInfo?.calendar?.openFrom ? (
              <LocalizationProvider
                dateAdapter={AdapterLuxon}
                adapterLocale={"ru"}
              >
                <StaticDatePicker
                  onChange={(newDate) => {
                    handleDatePickV2(newDate, "from");
                  }}
                  onClose={() => {
                    setFilterInfo((prevState) => ({
                      ...prevState,
                      calendar: { ...prevState?.calendar, openFrom: false },
                    }));
                  }}
                  views={["month", "day"]}
                  value={DateTime.fromSeconds(
                    _getValueFromFilter("timeFrameFrom", filterInfo?.filters),
                  )}
                  disablePast
                  maxDate={DateTime.fromSeconds(
                    _getValueFromFilter("timeFrameTo", filterInfo?.filters),
                  )}
                  slotProps={{
                    toolbar: {
                      hidden: true,
                    },
                  }}
                  slots={{
                    actionBar: () => null,
                  }}
                />
              </LocalizationProvider>
            ) : null}
            {filterInfo?.calendar?.openTo ? (
              <LocalizationProvider
                dateAdapter={AdapterLuxon}
                adapterLocale={"ru"}
              >
                <StaticDatePicker
                  onChange={(newDate) => {
                    handleDatePickV2(newDate, "to");
                  }}
                  onClose={() => {
                    setFilterInfo((prevState) => ({
                      ...prevState,
                      calendar: { ...prevState?.calendar, openTo: false },
                    }));
                  }}
                  views={["month", "day"]}
                  value={DateTime.fromSeconds(
                    _getValueFromFilter("timeFrameTo", filterInfo?.filters),
                  )}
                  disablePast
                  minDate={DateTime.fromSeconds(
                    _getValueFromFilter("timeFrameFrom", filterInfo?.filters),
                  )}
                  slotProps={{
                    toolbar: {
                      hidden: true,
                    },
                  }}
                  slots={{
                    actionBar: () => null,
                  }}
                />
              </LocalizationProvider>
            ) : null}
          </Box>

          <Box sx={{ p: 2 }}>
            <Stack
              direction={"row"}
              sx={{ justifyContent: "center" }}
              spacing={2}
            >
              <Button
                variant={"outlined"}
                onClick={() => {
                  setFilterInfo({ ...DEFAULT_FILTER_INFO_STATE, open: true });
                }}
                sx={{
                  flex: "1 1 auto",
                  maxWidth: "300px",
                }}
              >
                Сбросить
              </Button>
              <Button
                variant={"contained"}
                onClick={() => {
                  setFilters([...filterInfo.filters]);
                  setServices((prevState) => ({
                    ...prevState,
                    isLoaded: false,
                  }));
                  setFilterInfo((prevState) => ({ ...prevState, open: false }));
                }}
                sx={{
                  flex: "1 1 auto",
                  maxWidth: "300px",
                }}
              >
                Применить
              </Button>
            </Stack>
          </Box>
        </Stack>
      </FilterInfoV2>
      <ProfileModal open={profile.open} handleClose={handleProfileClose} />
      <BonusProgramMassageSpecialist
        open={bonusProgram.open}
        handleClose={handleBonusProgramClose}
      />
    </App>
  );
}

export default AppScreen;
